import { isAxiosError } from 'axios';
import { axiosAuth } from '@/axios';
import { Endpoints } from '@/enums';
import { ChangePassword } from '@/types/auth';

export const changePassword = async (
  newPasswordData: ChangePassword
): Promise<unknown> => {
  try {
    const res = await axiosAuth.post(Endpoints.ChangePassword, {
      ...newPasswordData,
    });
    return res;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
